// import { CallToActionOutlined } from "@mui/icons-material";
import {
  ADD_CONTENT_IN_PLAYLIST,
  ADD_PLAYLIST_SUCCESS,
  DELETE_CONTENT_FROM_PLAYLIST,
  DELETE_PLAYLIST,
  EDIT_PLAYLIST_NAME,
  GET_ONE_PLAYLIST,
  GET_PLAYLIST_SUCCESS,
  PLAYLIST_FLAG_OFF,
  UNCHECKED_TIME_LEBEL,
  UPDATE_DURATION,
  PLAYLIST_CONETNT_SORTING,
  ADD_PLAYLIST_FAILED,
  EDIT_PLAYLIST_DEMO_ATTRIBUTE,
  UPDATE_PLAYLIST_OPTIONS_SUCCESS,
  UPDATE_PLAYLIST_OPTIONS_FAILED,
  PLAYLIST_DUPLICATE_NAMES_ERROR,
} from "../constant";
import toast from "react-hot-toast";

const genRanHex = size => [...Array(size)].map(() => Math.floor(Math.random() * 16).toString(16)).join('');

const initial = {
  playlists: [],
  playlist: {},
  isPlaylistAdded: false,
  isPlaylistLoaded: false,
  isContentAdded: false,
  isOnePlaylist: false,
  isPlaylistContentSorted: false,
  duplicateNamesError: false
};
export const PlaylistReducer = (state = initial, action) => {
  switch (action.type) {
    case PLAYLIST_FLAG_OFF:
      return {
        ...state,
        isContentAdded: false,
        isOnePlaylist: false,
        isPlaylistLoaded: false,
        isPlaylistContentSorted: false,
        isPlaylistAdded: false,
      };
    case GET_PLAYLIST_SUCCESS:
      let getAllActiveList = [];
      action.payload.forEach((p, index) => {
        if(p.content[0]?.purpose !== "asset"){
          if (index === 0) {
            getAllActiveList.push({ ...p, isActive: true });
          } else {
            getAllActiveList.push({ ...p, isActive: false });
          }
        }
      });
      return {
        ...state,
        playlists: [...getAllActiveList].reverse(),
        isPlaylistLoaded: true,
      };
    case ADD_PLAYLIST_SUCCESS:
      return {
        ...state,
        isPlaylistAdded: true,
        playlists: [action.payload, ...state.playlists],
      };
    
    case 'SYNC_PLAYLIST_SETTINGS':
        return {
            ...state,
            playlists: [...state.playlists.filter(p => p._id !== action.payload._id), action.payload]
        }

    case GET_ONE_PLAYLIST:
      const newOneContent = [];
      const activeList = [];
      const oneP = state.playlists.find((p) => p._id === action.payload);
      if (!oneP) {
        return {
          ...state,
        };
      }
      const oneContents = oneP.content;
      oneContents.forEach((c) => {
        newOneContent.push({ ...c, timeChecked: false });
      });
      state.playlists.forEach((p) => {
        if (p._id === action.payload) {
          activeList.push({ ...p, isActive: true });
        } else {
          activeList.push({ ...p, isActive: false });
        }
      });
      return {
        ...state,
        isOnePlaylist: true,
        playlist: { ...oneP, content: newOneContent },
        playlists: activeList,
      };
    case DELETE_PLAYLIST:
      return {
        ...state,
        playlists: state.playlists.filter((p) => !action.payload.includes(p._id)),
      };
    case ADD_CONTENT_IN_PLAYLIST:
      const newContent = [];
      const playlistIndex = state.playlists.findIndex((playlist) => playlist._id === action.payload._id);
      const contents = action.payload.content;
      contents.forEach((c) => {
        newContent.push({ ...c, timeChecked: false });
      });
      state.playlists[playlistIndex] = {
        ...action.payload,
        content: newContent,
      };
      return {
        ...state,
        playlists: state.playlists,
        playlist: { ...action.payload, content: newContent },
        isContentAdded: true,
      };

      case 'ADD_CONTENT_LOCAL':
    case 'DELETE_CONTENT_LOCAL': {
      const { playlistId, items, contentId } = action.payload;
      const edit = (content) =>
        action.type === 'ADD_CONTENT_LOCAL'
          ? [...content, ...items]
          : content.filter((c) => c._id !== contentId);
      const patch = (p) => ({ ...p, content: edit(p.content || []) });
      return {
        ...state,
        playlists: state.playlists.map((p) => (p._id === playlistId ? patch(p) : p)),
        playlist: state.playlist?._id === playlistId ? patch(state.playlist) : state.playlist,
      };
    }

      case "PRE_ADD_CONTENT":
        const pIndex = state.playlists.findIndex(p => p._id == action.payload.id)
        // console.log(pIndex, state.playlists[pIndex])
        if (state.playlists[pIndex]?.content) {
            state.playlists[pIndex].content = [...state.playlists[pIndex].content, {
                duration: "0",
                _id: genRanHex(5),
                type: "addPlaceholder",
                content: true
            }]
            console.log(state.playlists)
            return {
                ...state,
                playlists: state.playlists,
                playlist: state.playlists[pIndex]
            }
        }else {
            return {
                ...state
            }
        }

    case "AFTER_ADD_CONTENT":
        const p2Index = state.playlists.find(p => p._id == action.payload.id)
        if (state.playlists[p2Index]?.content) {
            state.playlists[p2Index].content = state.playlists[p2Index]?.content?.filter(el => el.type !== 'addPlaceholder')
            return {
                ...state,
                playlists: state.playlists,
                playlist: state.playlists[p2Index]
            }
        }else {
            return {
                ...state
            }
        }

    case DELETE_CONTENT_FROM_PLAYLIST:
      const __playlist_content_index = state.playlists.findIndex((p) => p._id === action.payload.updatedPlaylist._id);
      state.playlists[__playlist_content_index] = {
        ...action.payload.updatedPlaylist,
      };
      state.playlist = {
        ...action.payload.updatedPlaylist,
        content: action.payload.updatedPlaylist.content.filter((c) => c._id !== action.payload.contentId),
      };
      return {
        ...state,
        playlist: state.playlist,
        playlists: state.playlists,
      };
    case UNCHECKED_TIME_LEBEL:
      const __playlist_index = state.playlists.findIndex((p) => p._id === action.payload.playlistId);
      const __content_index = state.playlists[__playlist_index].content.findIndex((c) => c._id === action.payload.contentId);
      const __getPlaylist = state.playlists[__playlist_index];
      const __getContents = __getPlaylist.content;
      __getContents[__content_index] = {
        ...__getContents[__content_index],
        timeChecked: true,
      };
      state.playlists[__playlist_index] = {
        ...state.playlists[__playlist_index],
        content: __getContents,
      };
      return {
        ...state,
        playlists: state.playlists,
        playlist: state.playlists.find((p) => p._id === action.payload.playlistId),
      };
    case UPDATE_DURATION:
      const { contentId, duration } = action.payload;
    
      // Aktualizuj playlistę w state.playlist
      const updatedPlaylist = {
        ...state.playlist,
        content: state.playlist.content.map(item =>
          item._id === contentId
            ? { ...item, duration: duration * 1000, timeChecked: false }
            : item
        )
      };
    
      // Aktualizuj również playlistę w state.playlists
      const updatedPlaylists = state.playlists.map(playlist =>
        playlist._id === state.playlist._id
          ? {
              ...playlist,
              content: playlist.content.map(item =>
                item._id === contentId
                  ? { ...item, duration: duration * 1000, timeChecked: false }
                  : item
              )
            }
          : playlist
      );
    
      return {
        ...state,
        playlist: updatedPlaylist,
        playlists: updatedPlaylists,
      };
      
    case EDIT_PLAYLIST_NAME:
      const __playlistIndex = state.playlists.findIndex((p) => p._id === action.payload._id);
      state.playlists[__playlistIndex] = { ...action.payload };
      return {
        ...state,
        playlists: state.playlists,
        playlist: { ...action.payload },
      };
    case EDIT_PLAYLIST_DEMO_ATTRIBUTE:
      const ___playlistIndex = state.playlists.findIndex((p) => p._id === action.payload._id);
      state.playlists[___playlistIndex] = { ...action.payload };
      return {
        ...state,
        playlists: state.playlists,
        playlist: { ...action.payload },
      };
    case PLAYLIST_CONETNT_SORTING:
      const _forSortingPlaylistIndex = state.playlists.findIndex((p) => p._id === action.payload.playlistId);
      const _contentList = state.playlists[_forSortingPlaylistIndex].content;

      const result = Array.from(_contentList);
      const [removed] = result.splice(action.payload.from, 1);
      result.splice(action.payload.to, 0, removed);

      state.playlists[_forSortingPlaylistIndex] = {
        ...state.playlists[_forSortingPlaylistIndex],
        content: result,
      };

      return {
        ...state,
        playlist: { ...state.playlist, content: result },
        playlists: state.playlists,
        isPlaylistContentSorted: true,
      };
    case ADD_PLAYLIST_FAILED:
      toast.error(action.payload);
      return {
        ...state,
        isContentAdding: false,
      };
    case UPDATE_PLAYLIST_OPTIONS_SUCCESS:
    //   toast.success("Playlist options successfully updated")
      const index = state.playlists.findIndex((p) => p._id === action.payload.playlistId);
      state.playlists[index] = { ...state.playlists[index], playlistOptions: action.payload.playlistOptions };
      return {
        ...state,
        playlists: state.playlists,
        // playlist: { ...state.playlist, playlistOptions: action.payload.playlistOptions },
      };
    case UPDATE_PLAYLIST_OPTIONS_FAILED:
      toast.error("Error while updating playlist options")
      return {
        ...state
      }
    case PLAYLIST_DUPLICATE_NAMES_ERROR:
      return {
        ...state,
        duplicateNamesError: action.payload
      }
    default:
      return state;
  }
};
